import { DEFAULT_TIME_ZONE } from '@akaal/trellis-ui'
import { defineStore } from 'pinia'
import { computed } from 'vue'

import { useAuthStore } from '@/stores/auth'

/**
 * The settings that every screen reads. Today that is the time zone for
 * datetimes (MRS 9): the zone of the user's profile, else the canonical zone
 * of GeneralSettings, else UTC. The API gives both with the signed-in user,
 * so a customer user has the canonical zone too.
 */
export const useSettingsStore = defineStore('settings', () => {
  const auth = useAuthStore()

  const canonicalTimezone = computed(() => auth.me?.canonical_timezone ?? null)
  const profileTimezone = computed(() => auth.me?.timezone ?? null)
  const timezone = computed(
    () => profileTimezone.value ?? canonicalTimezone.value ?? DEFAULT_TIME_ZONE,
  )

  return { canonicalTimezone, profileTimezone, timezone }
})
